import { Helmet } from "react-helmet";
import { DashboardLayout } from "../../../../../components/layouts/DashboardLayout";
import { Header } from "../../../../../components/Header";
import { useState } from "react";
import {
  FaArrowLeft,
  FaPenToSquare,
  FaTrashCan,
} from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { useHookOdcDetail } from "../../../../../hooks/useHookOdcDetail";
import { DetailInfoSectionOdc } from "./sections/detail_info";
import { CounterSectionOdc } from "./sections/CounterSection";
import { LocationAndImageOdcSection } from "./sections/location_and_images";

/* ============================================
   KOMPONEN: PopDetail
   ============================================ */
export const OdcDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [openSidebar, setOpenSidebar] = useState(false);
  const { data, loading, refreshData } = useHookOdcDetail({ id });
  const [currentLevel, setCurrentLevel] = useState("port");
  const [selection, setSelection] = useState({
    port: null,
    splitter: null,
    odc: null,
    odp: null,
  });

  // Mock Data disesuaikan dengan kebutuhan metadata hirarki
  const pop = {
    name: data?.name || "BYM2",
    nas: data?.nas?.name || "MikroTik-Core",
    total_port: data?.total_port || 2,
    jumlah_odc: data?.jumlah_odc || 1,
    jumlah_odp: data?.jumlah_odp || 2,
    user_pppoe: data?.user_pppoe || 12,
    coordinates: data?.lat && data?.lng ? `${data.lat}, ${data.lng}` : "-7.123456, 107.123456",
    ports: [
      {
        id: 1,
        name: "Port 1",
        splitters: [
          {
            id: 101,
            name: "Splitter 1:8 A",
            total_port: 8,
            odcs: [
              {
                id: 201,
                name: "ODC-BYM-01",
                initial_port: "A",
                total_port: 12,
                odps: [
                  {
                    id: 301,
                    name: "ODP-A1-01",
                    initial_port: "P1",
                    total_port: 8,
                    customers: ["User-01", "User-02"],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };

  const resetTo = (level) => {
    setCurrentLevel(level);
    if (level === "port") setSelection({ port: null, splitter: null, odc: null, odp: null });
    if (level === "splitter") setSelection((prev) => ({ ...prev, splitter: null, odc: null, odp: null }));
    if (level === "odc") setSelection((prev) => ({ ...prev, odc: null, odp: null }));
    if (level === "odp") setSelection((prev) => ({ ...prev, odp: null }));
  };


  return (
    <>
      <Helmet>
        <title>Infrastruktur {data?.name ?? ""} | DANELA NET</title>
        <meta name="description" content={`Detail infrastruktur dan manajemen jaringan ODC ${data?.name}.`} />
      </Helmet>

      <DashboardLayout showSidebar={openSidebar} setShowSidebar={setOpenSidebar}>
        {/* ===== Header ===== */}
        <Header showToggleSidebar={false} toggleSidebar={() => setOpenSidebar(!openSidebar)}>
          <div className="flex items-center justify-between w-full gap-4 flex-wrap md:flex-nowrap">
            <div className="flex items-center gap-4 py-2 min-w-0">
              <button
                onClick={() => navigate(-1)}
                className="p-2.5 rounded-xl text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 transition-all flex-shrink-0"
                style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
              >
                <FaArrowLeft />
              </button>
              <h1 className="font-extrabold tracking-tight text-gray-100 truncate">
                Detail Odc
              </h1>
            </div>
            {/* <button className="flex items-center gap-2 bg-cyan-600 text-white px-5 py-2.5 rounded-xl text-xs font-bold hover:bg-cyan-500 transition-all shadow-lg shadow-cyan-600/20 flex-shrink-0">
              <FaPlus /> Tambah {currentLevel.toUpperCase()}
            </button> */}
          </div>
        </Header>

        <div className="p-4 lg:p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {/* ===== Main Content Grid ===== */}
            <DetailInfoSectionOdc data={data} refreshData={refreshData} />

            <CounterSectionOdc data={data?.counter} />
            {/* ===== Counter Section ===== */}

          </div>
          {/* ===== Location & Image Section ===== */}
          <LocationAndImageOdcSection
            location={data?.address}
            images={data?.images}
            id={id}
            refreshData={refreshData}
          />

        </div>
      </DashboardLayout>
    </>
  );
};

/* ============================================
   SUB-COMPONENTS
   ============================================ */
const BreadcrumbItem = ({ label, active, onClick }) => (
  <button
    onClick={onClick}
    className={`text-[10px] font-black transition-all ${active ? "text-cyan-400" : "text-slate-500 hover:text-slate-300"
      }`}
  >
    {label}
  </button>
);



const TableRow = ({ index, name, cols, onView }) => (
  <tr
    className="transition-colors duration-150"
    style={{ background: "transparent" }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(0, 180, 216, 0.04)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
    }}
  >
    <td className="px-5 py-4 text-sm font-bold text-slate-500 font-mono">{index + 1}</td>
    <td className="px-5 py-4 text-sm font-bold text-gray-100">{name}</td>
    {cols.map((col, idx) => (
      <td key={idx} className="px-5 py-4 text-xs font-medium">
        {col}
      </td>
    ))}
    <td className="px-5 py-4">
      <div className="flex justify-center gap-2">
        <button
          onClick={onView}
          className="px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all uppercase tracking-wider text-cyan-400 hover:text-white"
          style={{ background: "rgba(0, 180, 216, 0.1)", border: "1px solid rgba(0, 180, 216, 0.2)" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(0, 180, 216, 0.8)";
            e.currentTarget.style.borderColor = "rgba(0, 180, 216, 0.8)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(0, 180, 216, 0.1)";
            e.currentTarget.style.borderColor = "rgba(0, 180, 216, 0.2)";
          }}
        >
          Buka Cabang
        </button>
        <button
          className="p-1.5 rounded-lg text-amber-400 transition-all"
          style={{ background: "rgba(245, 158, 11, 0.1)", border: "1px solid rgba(245, 158, 11, 0.2)" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(245, 158, 11, 0.8)";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.borderColor = "rgba(245, 158, 11, 0.8)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(245, 158, 11, 0.1)";
            e.currentTarget.style.color = "#fbbf24";
            e.currentTarget.style.borderColor = "rgba(245, 158, 11, 0.2)";
          }}
        >
          <FaPenToSquare size={12} />
        </button>
        <button
          className="p-1.5 rounded-lg text-red-400 transition-all"
          style={{ background: "rgba(239, 68, 68, 0.1)", border: "1px solid rgba(239, 68, 68, 0.2)" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(239, 68, 68, 0.8)";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.borderColor = "rgba(239, 68, 68, 0.8)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(239, 68, 68, 0.1)";
            e.currentTarget.style.color = "#f87171";
            e.currentTarget.style.borderColor = "rgba(239, 68, 68, 0.2)";
          }}
        >
          <FaTrashCan size={12} />
        </button>
      </div>
    </td>
  </tr>
);